import { BrowserProvider } from "ethers";

export const SET_PROVIDER = 'SET_PROVIDER';

export interface ISetProviderAction {
  type: typeof SET_PROVIDER;
  payload: {provider: BrowserProvider};
}

export type Web3ActionTypes = ISetProviderAction;
